var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandStrapiStyleBrand = function SvgBrandStrapiStyleBrand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandStrapiStyleBrand__clip0_3952_116335)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4945FF",
    d: "M0 8.32c0-3.922 0-5.883 1.218-7.102C2.437 0 4.398 0 8.32 0h7.36c3.922 0 5.883 0 7.102 1.218C24 2.437 24 4.398 24 8.32v7.36c0 3.922 0 5.883-1.218 7.102C21.563 24 19.602 24 15.68 24H8.32c-3.922 0-5.883 0-7.101-1.218C0 21.563 0 19.602 0 15.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.56 7.28H8.48v4.12h4.12v4.12h4.12V7.44a.16.16 0 0 0-.16-.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.44 11.4h.16v.16h-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9593FF",
    d: "M8.48 11.4h3.96a.16.16 0 0 1 .16.16v3.96H8.64a.16.16 0 0 1-.16-.16zm4.12 4.12h4.12l-3.984 3.983a.08.08 0 0 1-.136-.056zM8.48 11.4H4.553a.08.08 0 0 1-.057-.136L8.48 7.28z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandStrapiStyleBrand__clip0_3952_116335"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandStrapiStyleBrand);
export { ForwardRef as ReactComponent };